import { Col, Row, UncontrolledTooltip } from "reactstrap";

import DateTime from "luxon/src/datetime.js";

import { withTranslation } from "react-i18next";

const TooltipActivitySummary = ({ t, ...props }) => {
  return (
    <UncontrolledTooltip
      placement="left"
      target={props.target}
      className="uncontrolledTooltip csatTooltip"
    >
      <div className="headerCsat">
        <div className="title">
          {props.title}
          <span className="desc">{props.message}</span>
        </div>
        <hr />
        <Row className="info">
          <Col sm="12">
            <span className="leftItem">{t("Last update")}:</span>
            {props.lastUpdate
              ? DateTime.fromJSDate(new Date(props.lastUpdate)).toFormat(
                  "dd MMM yyyy - HH:mm"
                )
              : "-"}
          </Col>
          <Col sm="12">
            <span className="leftItem">{t("Interval")}:</span>
            {props.interval ?? "-"}
          </Col>
        </Row>
      </div>
    </UncontrolledTooltip>
  );
};

export default withTranslation()(TooltipActivitySummary);
